export const PILLAR_TRANSLATIONS = {
  connection: {
    name: 'Connection',
    whenPresent: [
      'You feel emotionally close and open',
      'There is real intimacy, not just interaction'
    ],
    whenMissing: [
      'It feels surface-level or disconnected'
    ],
    whatItPointsTo: [
      'A need for emotional closeness and trust'
    ]
  },
  desire: {
    name: 'Desire',
    whenPresent: [
      'You feel wanted, pursued, or pulled in'
    ],
    whenMissing: [
      'You feel appreciated, but not desired'
    ],
    whatItPointsTo: [
      'A need for visible attraction and initiation'
    ]
  },
  novelty: {
    name: 'Novelty',
    whenPresent: [
      'Things feel fresh and engaging'
    ],
    whenMissing: [
      'It feels predictable or repetitive'
    ],
    whatItPointsTo: [
      'A need for variation or new energy'
    ]
  },
  power: {
    name: 'Power',
    whenPresent: [
      'There is tension, contrast, or charge'
    ],
    whenMissing: [
      'It feels flat or neutral'
    ],
    whatItPointsTo: [
      'A need for polarity or dynamic roles'
    ]
  },
  play: {
    name: 'Play',
    whenPresent: [
      'It feels light, free, and natural'
    ],
    whenMissing: [
      'It feels serious or effortful'
    ],
    whatItPointsTo: [
      'A need for ease and spontaneity'
    ]
  }
};

// Map from intent to how it feels when aligned
export const INTENT_DESCRIPTORS = {
  connection: { aligned: 'close, intimate, and deeply personal', misaligned: 'disconnected or surface-level' },
  desire: { aligned: 'charged, wanted, and alive', misaligned: 'flat, mutual but not electric' },
  exploratory: { aligned: 'fresh, curious, and stimulating', misaligned: 'predictable and routine' },
  power: { aligned: 'tense, dynamic, and charged', misaligned: 'neutral and equal but lifeless' },
  playful: { aligned: 'light, free, and easy', misaligned: 'heavy, pressured, or performative' },
  physical: { aligned: 'satisfying, direct, and uncomplicated', misaligned: 'empty or mechanical' }
};
